module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Sec"
  }, [_c('div', {
    staticClass: "altSch"
  }, [_c('span', [_vm._v("所在学校 :")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.school
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4166ac9c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personMsg/teachMsg.vue
// module id = 1190
// module chunks = 1